// YouTube Gallery block schema - Synced video gallery from profile
export const youtubeGallerySchema = {
  type: 'youtube-gallery',
  label: 'YouTube Gallery',
  description: 'Display your YouTube videos (synced with profile)',
  icon: 'Youtube',
  defaultContent: {
    heading: 'My Videos',
    showAll: true, // Show all videos from profile
    selectedVideoIds: [], // If showAll is false, show only these
    layout: 'grid', // 'grid' | 'featured' (large first + grid)
    maxVideos: 6, // Max videos to show (0 = unlimited)
    showTitles: true,
    showDescriptions: false,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Section Heading', type: 'text', placeholder: 'My Videos' },
    {
      name: 'layout',
      label: 'Layout',
      type: 'select',
      options: [
        { value: 'grid', label: 'Grid' },
        { value: 'featured', label: 'Featured (Large first)' },
      ],
    },
    { name: 'maxVideos', label: 'Max Videos', type: 'number', min: 0, max: 20 },
    { name: 'showTitles', label: 'Show Titles', type: 'checkbox' },
    { name: 'showDescriptions', label: 'Show Descriptions', type: 'checkbox' },
  ],
};
